import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye } from 'react-icons/fi';
import { ProjectCardProps } from '../../../../Interfaces/FeatureFlip';
import styles from './ProjectCard.module.css';

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const navigate = useNavigate();

  const handleViewProject = () => {
    navigate(`/feature-flip/project/${project.id}/features`);
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h3 className={styles.title}>{project.name}</h3>
        </div>
        <button onClick={handleViewProject} className={styles.viewButton}>
          <FiEye />
          View Project
        </button>
      </div>
      <p className={styles.description}>{project.description}</p>
     
    </div>
  );
};

export default ProjectCard; 